import { render } from "./FinansalVeriler.vue?vue&type=template&id=dea6b924&scoped=true"
import script from "./FinansalVeriler.vue?vue&type=script&lang=js"
export * from "./FinansalVeriler.vue?vue&type=script&lang=js"

import "./FinansalVeriler.vue?vue&type=style&index=0&id=dea6b924&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea6b924"]])

export default __exports__